export const fileDownloader=(url,filename)=>{
    const documentUrl = url;
    const link = document.createElement('a');
    link.href = documentUrl;
    link.target = '_blank';
    link.download = filename;
    link.click();
}